/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import LogPage from './Components/LogPage';
import { makeStyles } from '@material-ui/core';
import { Redirect, Switch, useLocation } from 'react-router-dom';
import { ContentRoute } from '../../_metronic/layout';
import ChangePassFn from './Components/ChangePassword';
import PasswordRequest from './Components/PasswordRequest';
import logo_infonavit from '../../assets/logos/logo_infonavit.svg';
import logo_filial from '../../assets/logos/logo-filial.jpg';
import '../../_metronic/_assets/sass/pages/login/classic/login-1.scss';

export function AuthPage() {
	const location = useLocation();
	const [loading, setLoading] = useState(true);
	const queryParams = new URLSearchParams(location.search);
	const ref = queryParams.get('type');
	const useStyles = makeStyles((theme) => ({
		fondo: {
			backgroundColor: '#FFFFFF',
			height: '100%',
			justifyContent: 'center',
			display: 'flex',
			alignItems: 'center',
			alignContent: 'center',
			position: 'relative',
			overflow: 'auto',
		},
		fondo2: {
			background: 'White',
			margin: 'auto',
			padding: '40px',
			maxWidth: '550px',
			borderRadius: '10px',
			boxShadow: '0px 0px 29px -8px rgba(0,0,0,0.39)',
		},
		h1: { color: '#DD052B' },
		version: {
			color: '#bebebe',
			display: 'flex',
			position: 'absolute',
			bottom: 2,
			right: 15,
		},
	}));

	const classes = useStyles();
	const changePass = useSelector((state) => state.changePassword.changePassword);
	const passRequest = useSelector((state) => state.passwordRequest.passwordRequest);

	useEffect(() => {
		const timer = setTimeout(() => {
			setLoading(false);
		}, 3500);

		return () => clearTimeout(timer);
	}, []);

	useEffect(() => {
		if (ref) {
			localStorage.setItem('type', 'filial');
		} else {
			localStorage.removeItem('type');
		}
	}, [ref]);

	if (loading) {
		return (
			<div className="skeleton-container">
				<div className="skeleton skeleton-logo"></div>
				<div className="skeleton skeleton-title"></div>
				<div className="skeleton skeleton-box"></div>
				<p className="skeleton skeleton-text"></p>
			</div>
		);
	}

	return (
		<>
			<div className={classes.fondo}>
				<div>
					{/*begin::Login*/}
					<div className={classes.fondo2}>
						{/*begin::Aside*/}
						<div className="w-100 text-center justify-content-center align-items-center ">
							<div className="flex-column align-items-center ">
								<img
									src={ref ? logo_filial : logo_infonavit}
									alt="logo"
									width={ref ? '70%' : '48%'}
								/>
								<div className="flex-column align-items-center mt-lg-8">
									{!ref && (
										<h1 className={classes.h1}>
											Sistema de Administración de Órganos
											Colegiados
										</h1>
									)}
								</div>
							</div>
						</div>
						<div className="w-100 h-100 ">
							<div className="d-flex flex-column-fluid flex-center h-100 ">
								{changePass === false && (
									<Switch>
										<ContentRoute
											path="/auth/login"
											component={LogPage}
										/>
										<Redirect
											from="/auth"
											exact={true}
											to="/auth/login"
										/>
										<Redirect to="/auth/login" />
									</Switch>
								)}
								{changePass === true && (
									<Switch>
										<ContentRoute
											path="/auth/login"
											component={ChangePassFn}
										/>
										<Redirect
											from="/auth"
											exact={true}
											to="/auth/login"
										/>
										<Redirect to="/auth/login" />
									</Switch>
								)}
								{passRequest === true && (
									<Switch>
										<ContentRoute
											path="/auth/login"
											component={PasswordRequest}
										/>
										<Redirect
											from="/auth"
											exact={true}
											to="/auth/login"
										/>
										<Redirect to="/auth/login" />
									</Switch>
								)}
							</div>
						</div>

						{/*begin::Aside*/}

						{/*begin::Content*/}
						{/*end::Content*/}
					</div>

					{/*end::Login*/}
				</div>
				<p className={classes.version}>Versión 3.1.0</p>
			</div>
		</>
	);
}
